export const COUPON_STATUS = {
  public: '配布中',
  private: '配布停止',
  deleted: '削除済',
}

export const COUPON_DISCOUNT_TYPE = {
  flat_rate: '定額割引',
  percent: 'パーセント割引',
}

export const PER_PAGE = 50
